<template>
  <v-container fluid>
    <general-dialog v-model="modal" :title="popupTitle" :buttons="buttons">
      <v-card flat>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12">
                <p>마지막 비밀번호 변경후 180일이 지났습니다.</p>
                <p>비밀번호 변경을 권장드립니다. 변경하시겠습니까?</p>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </general-dialog>
    <!--<v-dialog v-model="component_show">
      <v-card class="top_title"> &nbsp; 공지사항</v-card>
        <v-card>
          <span>
            &nbsp; <input type="checkbox" :id="'chkToday'"> &nbsp;5일동안 열지 않음 &nbsp;
            <v-btn varient="plain" size="small" @click="closeLayer"> 닫기</v-btn>
          </span>
        </v-card>
      <div class="main_content">
        <img src="@/assets/image/popup.jpg" width="100%">
      </div>
    </v-dialog>-->
    <v-row class="justify-center">
      <v-col cols="6" md="2" class="py-2 pr-2 pl-3">
        <gauge-card
          title="발전량"
          :max="siteTotal.totalCapacity * 1.1"
          :value="siteTotal.pvpcsPac"
          color="#90F072"
          unit="kW"
          :flag="flag"
        />
      </v-col>
      <v-col cols="6" md="2" class="py-2 pl-2 pr-3">
        <text-card
          title="당일 발전량"
          :value="siteTotal.pvpcsDailyP / 1000"
          color="#00FFFA"
          unit="kW"
        ></text-card>
      </v-col>
      <v-col cols="6" md="2" class="py-2 pr-2 pl-3">
        <state-table
          title="사이트 현황"
          state-name="총사이트"
          :state-value="siteTotal.totalCount"
          :run-val="siteTotal.runCount + siteTotal.pauseCount"
          :err-val="siteTotal.faultCount"
          :str-val="siteTotal.errorCount"
        ></state-table>
      </v-col>
      <v-col cols="6" md="2" class="py-2 pl-2 pr-3">
        <state-table
          title="인버터 현황"
          state-name="총인버터"
          :state-value="inverterTotal.totalCount"
          :run-val="inverterTotal.runCount + inverterTotal.pauseCount"
          :err-val="inverterTotal.faultCount"
          :str-val="inverterTotal.errorCount"
        ></state-table>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <!--          <v-checkbox label="전체" class="mr-2"></v-checkbox>-->
      <!--          <v-checkbox label="유료" class="mr-2"></v-checkbox>-->
      <!--          <v-checkbox label="무료" class="mr-2"></v-checkbox>-->
      <v-col cols="12" md="3" class="lg5-custom">
        <!-- <v-text-field
          class="search_text_field"
          placeholder="사이트명을 입력하세요"
          outlined
          dense
          hide-details
          v-model="searchText"
          @keyup.enter="searchSite"
        >
          <template v-slot:append-outer>
            <v-btn color="#0784F2" height="44" @click="searchSite">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
        </v-text-field>-->
        <v-select
          :items="selectList"
          v-on:change="changeSido"
          v-model="selectItem"
          outlined
          sm
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <!-- <v-row class="justify-center">
      <template v-if="sidoList">
        <v-carousel height="100%" hide-delimiters show-arrows hide-delimiter-background>
          <v-carousel-item v-for="(sido, index) in sidoList" :key="index" hide-controls>
            <expansion-gauge-card
              :sido="sido"
              :sigu-list="sido.runList"
              :flag="flag"
              :sido-total="sidoTotal"
            ></expansion-gauge-card>
          </v-carousel-item>
        </v-carousel>
      </template>
    </v-row>-->
    <v-row class="justify-center">
      <template v-if="sidoList">
        <v-layout
          class="d-flex flex-column"
          height="100%"
          hide-delimiters
          show-arrows-on-hover
          hide-delimiter-background
        >
          <v-card
            class="mb-3"
            v-for="(sido, index) in sidoList"
            :key="index"
            hide-controls
          >
            <expansion-gauge-card
              :sido="sido"
              :sigu-list="sido.runList"
              :flag="flag"
              :sido-total="sidoTotal"
            ></expansion-gauge-card>
          </v-card>
        </v-layout>
      </template>
    </v-row>
    <v-dialog v-model="popup" persistent max-width="450px" scrollable>
      <detail-status-popup
        @closeDetailPop="popup = false"
        @siteName="emitSearchSite"
        :list="paramList"
        status="search"
      ></detail-status-popup>
    </v-dialog>
  </v-container>
</template>

<script>
import { dateRenew } from '@/api/common/login'

import GaugeCard from '@/components/mobile/m_GaugeCard'
import ExpansionGaugeCard from '@/components/mobile/ExpansionGaugeCard'
import TextCard from '@/components/mobile/TextCard'
import StateTable from '@/components/mobile/StateTable'
import { getMonitoringTotal, getSearchSite } from '@/api/monitoring/monitoring'
import DetailStatusPopup from '@/components/monitoring/DetailStatusPopup'
import localStore from '@/utils/localStore'
import GeneralDialog from '@/components/dialogSet/GeneralDialog'
import store from '@/store'
import { isMobile } from '@/utils/check.js'
import { confirmIfExit } from '@/api/greenCommon/confirmIfExit'

export default {
  name: 'mob_Constructor',
  components: {
    GaugeCard,
    ExpansionGaugeCard,
    TextCard,
    StateTable,
    DetailStatusPopup,
    GeneralDialog
  },
  data() {
    return {
      row_num: 0,
      component_key: 1,
      layer_type: 'SummaryPopup',
      component_show: false,
      isMobilePc: false,
      flag: 0,
      sidoTotal: 0,
      searchText: '',
      popupTitle: '비밀번호 변경',
      pwChangeYN: localStore.get('pw_change'),
      buttons: [
        {
          title: '변경',
          color: 'primary',
          class: 'white--text',
          handler: () => {
            this.closePopup({ ok: true })
          }
        },
        {
          title: '다음에 변경하기',
          text: true,
          handler: () => {
            this.closePopup({ ok: false })
          }
        }
      ],
      popup: false,
      paramList: [],
      selectList: [],
      selectItem: '전체',
      siteTotal: {
        dailyTime: 0,
        errorCount: 0,
        expectPrice: 0,
        faultCount: 0,
        pauseCount: 0,
        pvpcsDailyP: 0,
        pvpcsPac: 0,
        runCount: 0,
        totalCapacity: 0,
        totalCount: 0
      },
      inverterTotal: {
        dailyTime: 0,
        errorCount: 0,
        expectPrice: 0,
        faultCount: 0,
        pauseCount: 0,
        pvpcsDailyP: 0,
        pvpcsPac: 0,
        runCount: 0,
        totalCapacity: 0,
        totalCount: 0
      },
      sidoList: {},
      allSidoList: {},
      sigu: {},
      intervalHandler: null
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
  },
  mounted() {
    this.popup2()
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
    this.getData()
    if (isMobile()) {
      this.isMobilePc = true
      // confirmIfExit()
    }
    this.intervalHandler = setInterval(() => {
      this.getData()
    }, 60000 * 2)
    if (this.pwChangeYN === 'Y') {
      this.modal = true
    } else {
    }
  },
  computed: {},
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    popup2() {
      // 첫 화면에서 팝업을 띄운다
      this.layer_type = 'SummaryPopup'

      let found = false
      let start, end
      let i = 0

      while (i <= document.cookie.length) {
        start = i
        end = start + 'popup'.length
        if (document.cookie.substring(start, end) === 'popup') {
          found = true
          break
        }
        i++
      }

      if (found === true) {
        console.log('cookie found')
        this.component_show = false
      } else {
        console.log('cookie not found')
        this.component_show = true
      }
      // this.component_show = true
    },
    closeLayer() {
      if (document.getElementById('chkToday').checked) {
        let todayDate = new Date()
        todayDate.setDate(todayDate.getDate() + 5)
        document.cookie =
          'popup' +
          '=' +
          escape('no') +
          '; path=/; expires=' +
          todayDate.toGMTString() +
          ';'
        this.component_show = false
      } else {
        this.component_show = false
      }
    },
    closePopup(result) {
      if (result.ok) {
        this.modal = false
        this.$router.replace('/mypage')
      } else {
        this.modal = false
        dateRenew(localStore.get('userId'))
        localStore.set('pw_change', '')
      }
    },
    changeSido(v) {
      this.sidoList = {}
      if (v === '전체') {
        this.sidoList = this.allSidoList
      } else {
        for (let key in this.allSidoList) {
          if (this.allSidoList[key].sidoName === v) {
            // this.sidoList.push(this.allSidoList[key])
            // this.sidoList = this.allSidoList[key]
            const obj = this.allSidoList[key]
            this.sidoList[key] = obj
          }
        }
      }
    },
    fn1() {
      // 내부 state인 data영역은 this로 접근해야 한다.
      this.count++
    },
    clickMe() {
      this.value = this.value + 1
    },
    getSiguList(sidoCode) {
      const siguList = []
      for (let siguCode in this.sigu) {
        if (this.sigu[siguCode].sidoCode === sidoCode) {
          siguList.push(this.sigu[siguCode])
        }
      }
      return siguList
    },
    getData() {
      getMonitoringTotal(store.state.user.userId, 'sigu').then(res => {
        const list = res.sigu
        console.log(res)
        this.selectList.push('전체')
        for (let key in list) {
          this.selectList.push(res.sigu[key].sidoName)
        }
        if (res.siteTotal) {
          this.siteTotal = res.siteTotal
        }
        if (res.sigu) {
          this.sidoTotal = Object.keys(res.sigu).length
          this.sidoList = res.sigu
          this.allSidoList = res.sigu
        }
        if (res.sigu) {
          this.sigu = res.sigu
        }
        if (res.inverterTotal) {
          this.inverterTotal = res.inverterTotal
        }
        this.flag++
      })
    },
    searchSite() {
      if (this.searchText !== '') {
        getSearchSite(this.searchText, store.state.user.userId).then(res => {
          this.paramList = res
          this.popup = true
        })
      } else {
        // Message.warn('검색어 입력!!')
      }
    },
    emitSearchSite(siteName) {
      this.searchText = siteName
      this.searchSite()
    }
  },
  beforeDestroy() {
    if (this.intervalHandler) clearInterval(this.intervalHandler)
  }
}
</script>

<style lang="scss"></style>
